import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CoreModule } from '../../../core/core.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslatePipe } from '@ngx-translate/core';
import { ProjectBimBuildingPlansComponent } from './project-bim-building-plans.component';
import { MapPopupComponent } from '../project-building-plans/map-popup/map-popup.component';

@NgModule({
    imports: [CommonModule, FormsModule, IonicModule, CoreModule, FontAwesomeModule, NgSelectModule, TranslatePipe],
    declarations: [ProjectBimBuildingPlansComponent, MapPopupComponent],
    exports: [ProjectBimBuildingPlansComponent, MapPopupComponent],
})
export class SharedBimBuildingPlansModule {}
